import "./index.css";

import { StrictMode, Suspense } from "react";
import { createRoot } from "react-dom/client";
import { RouterProvider } from "react-router";

import { AuthProvider } from "./components/auth/AuthProvider";
import { ErrorBoundary } from "./components/ui/ErrorBoundary";
import { LoadingScreen } from "./components/ui/LoadingScreen";
import { initPosthog } from "./lib/posthog";
import { router } from "./routes";

// Defer PostHog init until the browser is idle
if (typeof requestIdleCallback === "function") {
  requestIdleCallback(() => void initPosthog());
} else {
  setTimeout(() => void initPosthog(), 1);
}

createRoot(document.getElementById("root")!).render(
  <StrictMode>
    <ErrorBoundary label="Application error">
      <AuthProvider>
        <Suspense fallback={<LoadingScreen />}>
          <RouterProvider router={router} />
        </Suspense>
      </AuthProvider>
    </ErrorBoundary>
  </StrictMode>
);
